import { DateTime } from 'luxon';
import { Admin } from '../admin/admin';
import { CycleBillingTerms, OrderReturnStatus, OrderStatus, OrderType } from '../order/order';

export enum EntityType {
  Order = 'Order',
  OrderProduct = 'OrderProduct',
  // TODO: add more types
}
export enum EventType {
  StatusUpdate = 'StatusUpdate',
  OrderUpdate = 'OrderUpdate',
  OrderCreated = 'OrderCreated',
}

export class Event {
  readonly id!: string;
  readonly entityType!: EntityType;
  readonly entityId?: number;
  readonly entityUuid?: string;
  readonly eventType!: EventType;
  readonly timestamp!: DateTime;
  readonly admin?: Admin;
  readonly metadata?: any;
}

export type OrderUpdateMetadata = {
  products: {
    added: {
      productId: number;
      orderProductId: number;
      quantity: number;
      type: OrderType;
      rentalStartDate?: DateTime;
      rentalEndDate?: DateTime;
    }[];
    removed: { productId: number; orderProductId: number; quantity: number; type: OrderType }[];
    updated: {
      productId: number;
      orderProductId: number;
      quantity?: number;
      rentalStartDate?: DateTime;
      rentalEndDate?: DateTime;
      unitPrice?: number;
      assignedUnits?: number[];
      unassignedUnits?: number[];
      fees?: {
        added: { attributeId: number; amount: number; name: string }[];
        removed: { attributeId: number; amount: number; name: string }[];
        updated: { attributeId: number; amount: number; name: string }[];
      };
    }[];
  };
  damageWaiver?: number;
  deliveryMethod?: string;
  deliveryFee?: number;
  additionalDiscount?: number;
  taxPercentage?: { taxPercentage: number; amount?: number };
  taxCode?: string;
  coupon?: string;
  fees?: {
    added: {
      feeId: number;
      name: string;
      amount: number;
    }[];
    removed: {
      feeId: number;
      name: string;
      amount: number;
    }[];
    updated: {
      feeId: number;
      name: string;
      amount: number;
    }[];
  };
  isCycleBilled?: boolean;
  cycleBillingTerms?: CycleBillingTerms;
};

export type OrderStatusUpdateMetadata = {
  status?: [OrderStatus, OrderReturnStatus] | OrderReturnStatus | OrderStatus;
  prevStatus?: [OrderStatus, OrderReturnStatus] | OrderReturnStatus | OrderStatus;
  products?: {
    productId: number;
    status: OrderReturnStatus;
    prevStatus?: OrderReturnStatus;
    statusTimestamp?: DateTime;
  }[];
};

export type OrderCreatedMetadata = {
  products: {
    productId: number;
    orderProductId: number;
    quantity: number;
    type: OrderType;
    rentalStartDate?: DateTime;
    rentalEndDate?: DateTime;
    unitPrice?: number;
  }[];
  damageWaiver?: number;
  deliveryMethod?: string;
  deliveryFee?: number;
  additionalDiscount?: number;
  taxPercentage: { taxPercentage: number; amount?: number };
  taxCode?: string;
  coupon?: string;
  fees?: {
    added: { feeId: number; name: string; amount?: number }[];
  };
  isCycleBilled?: boolean;
  cycleBillingTerms?: CycleBillingTerms;
};
